export enum HHDSInputType {    
    Text = 'text',
    Email = 'email',
}